import React, { useCallback, useMemo, useState } from "react";
import { SlidableMenu } from "../../components/slidableMenu/SlidableMenu";
import { CalendarGrid } from "../../components/calendarGrid/CalendarGrid";
import "./DesktopPage.css";
import { getAvatarByKey, getAvatarList } from "../../utils/avatars";
import { uploadAvatar } from "../../api/api";
import { Editor3 } from "./editor3";
import { SelectTime } from "../../components/selectTime/SelectTime";
import { Mindmap } from "./Mindmap";
import { GoodScroll } from "./GoodScroll";
import { AnimatedMenu } from "./AnimatedMenu";
import { GViewer } from "./GViewer";
import { AnimatedList } from "./AnimatedList";
import { DateLine } from "../../components/dateLine/DateLine";

export const DesktopPage = () => {
    const items = useMemo(()=> new Array(100).fill(0).map((it, i)=>'23563453424523'.slice(0, Math.floor(Math.random() * 10 + 1))), []);
    const [collapserState, setCollapserState] = useState('both');
    const [femaleList, setFemaleList] = useState<Record<string, string>>({});
    const initDate = useMemo(()=>{return new Date()}, []);
    const [testList, setTestList] = useState<{name: string, id: string}[]>([{name:'test', id: 'test'}]);
    return (
        <div className="desktopPage">
            <div className="desktopPage_background">
            
            </div>
            <div className="desktopPage_wrapper">
                <SlidableMenu items={items}></SlidableMenu>
                <div>
                    <button onClick={()=>setCollapserState('both')}>both</button>
                    <button onClick={()=>setCollapserState('left')}>left</button>
                    <button onClick={()=>setCollapserState('right')}>right</button>
                </div>
                <div className={`desktopPage_doubleCollapser desktopPage_doubleCollapser--${collapserState}`} style={{height: "300px", flexShrink: 0}}>
                    <div className="desktopPage_doubleCollapser_side desktopPage_doubleCollapser_left">
                        <div className="desktopPage_doubleCollapser_content">
                                32423456789809 hg ggh ghhghg  
                        </div>
                        <div className="desktopPage_doubleCollapser_content_holder_zero">
                            <div className="desktopPage_doubleCollapser_content_holder">
                                cl
                            </div>
                        </div>
                    </div>
                    <div className="desktopPage_doubleCollapser_side desktopPage_doubleCollapser_right">
                        <div className="desktopPage_doubleCollapser_content">
                            324354678908989 uhjj j jg jh khjjh
                        </div>
                    </div>   
                </div>

                {/*<CalendarGrid></CalendarGrid>*/}

                <Editor3></Editor3>
                <SelectTime selectedDate={initDate} onSelect={(d)=>{console.log('date ', d)}}></SelectTime>
                <Mindmap></Mindmap>
                <GoodScroll></GoodScroll>
                <AnimatedMenu items={['one', 'long text item', 'three', 'four']} onSelect={()=>{}} selectedIndex={0}></AnimatedMenu>
                <GViewer callModal={()=>{console.log('not impl.')}}></GViewer>
                <DateLine label="test"></DateLine>
                <button onClick={()=>{
                    setTestList(last=>{
                        const next = [...last];
                        if (Math.random()<0.8){
                            next.splice(Math.floor(Math.random() *  last.length), 0, {name: 'test'+ Math.random(), id:'test'+ Math.random()})
                        }
                        if (Math.random()<0.3){
                            next.splice(Math.floor(Math.random() *  last.length), 1);
                        }
                        return next;
                    })
                }}>rnd</button>
                <AnimatedList dataList={testList}></AnimatedList>
                {/*<div>
                    <input type="file" onChange={(e)=>{
                        const file = e.target.files[0];
                        if (file){
                            uploadAvatar(file, ()=>{

                            }).then(res=>{
                                console.log(res);
                            });
                        }
                    }}></input>
                </div>*/}

                <div>
                    {getAvatarList().map(it=>{
                        return <div style={{background: `${femaleList[it] ? "#f99" : ""}`}} onClick={()=>{setFemaleList(last=> {
                            const newList = {...last};
                            if (newList[it]){
                                delete newList[it];
                            } else {
                                newList[it] = it
                            }
                            console.log(newList)
                            return newList;
                        })}}><img src={getAvatarByKey(it)} style={{width: "60px"}}/>{it}</div>
                    })}
                </div>
            </div>
        </div>
    )
}